import React from 'react';

import PropTypes from 'prop-types';

import Actions from './Actions';
import { getStatus, getLocalFormattedTime } from './utils';

const Row = ({ order, fetchOrders, headers }) => {
  const { orderId, businessLegalName, productInOrderFor, createdAt } = order;
  const { statusId, statusToolTip } = getStatus(order);

  return (
    <tr>
      <td data-header-label={headers[0]}>{orderId}</td>
      <td data-header-label={headers[1]}>{businessLegalName}</td>
      <td data-header-label={headers[2]}>{productInOrderFor}</td>
      <td data-header-label={headers[3]}>{getLocalFormattedTime(createdAt)}</td>
      <td data-header-label={headers[4]}>{statusToolTip}</td>
      <td data-header-label={headers[5]}>New</td>
      <td data-header-label={headers[6]}>
        <div className="responsive-table__actions">
          <Actions status={statusId} order={order} fetchOrders={fetchOrders} />
        </div>
      </td>
    </tr>
  );
};

Row.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired,
  headers: PropTypes.number.isRequired
};

export default Row;
